import 'babel-polyfill';
import Vue from 'vue';
import Router from 'vue-router';
import axios from 'axios'
import store from '../store';
import routeNames from './routeNames';

axios.defaults.headers['Access-Control-Allow-Origin'] = '*'
axios.defaults.headers['Access-Control-Allow-Headers'] = 'Origin, X-Auth-Token, X-Requested-With, Authorization, Content-Type, Accept'
axios.defaults.headers['Access-Control-Allow-Methods'] = 'HEAD, POST, GET, PUT, PATCH, DELETE, OPTIONS'

// redirect to login on 401 from api
 axios.interceptors.response.use(null, async (err) => {
  if(err){ 
     if (err.response.status === 401 && err.config && !err.config.__isRetryRequest) {
       window.localStorage.removeItem('msal.idtoken');
       await window.$authservice.login();
     }
    }
 });

 // inject msal token
 axios.interceptors.request.use((config) => {
   const token = window.localStorage.getItem('msal.idtoken');
   if (token) {
     config.headers.Authorization = `Bearer ${token}`;
   }
   return config;
 });

Vue.use(Router);

const router = new Router({
  routes: routeNames.Routes,
  linkActiveClass: 'active',
  mode: 'history'
});
window.$router = router;

// Global route guard, login if route requires authentication
router.beforeEach(async (to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuthentication)) {
    await store.dispatch("auth/checklogin");
    if (store.getters.userLoggedIn) {
      next();
    } else {
        await store.dispatch("auth/login");
    }
  } else {
    next();
  }
});

export default router;

